import React, { memo } from 'react';
import { Typography } from 'antd';

const { Link } = Typography;

interface Props {
	className?: string;
	taskId: number;
	externalId: string;
}

function LinkCell({ className, taskId, externalId }: Props) {
	return (
		<Link
			className={className}
			href={`#/history/${taskId}`}
			title={externalId}
			target="_blank"
			rel="noopener noreferrer"
		>
			{externalId}
		</Link>
	);
}

export default memo(LinkCell);
